// extracted by mini-css-extract-plugin
export default {"ellipsis":"mQ8ECpGdXqQVmjrfxmSk","ellipsis1":"M2slbQ3Q8vouoJSIuNUg","ellipsis2":"P2_roR5jj_3mG9_yRM6C","ellipsis3":"q9sHjh1bmxhdM2sf4HuZ"};